/**
 * The place where most of the custom JavaScript should be found.
 */

import riAnimate from "rianimate" 

riAnimate();

import Glide from "@glidejs/glide"

var glide = new Glide('.glide', {
    autoplay: 8000,
    hoverpause: true,
    
})

var isGlide = document.getElementsByClassName('glide');
if (isGlide?.length > 0) {
    glide.mount()
}

function enableSiteOverlay() {
    document.querySelector( 'site-overlay' )?.classList.add( 'active' )
}

function disableSiteOverlay() {
    document.querySelector( 'site-overlay' )?.classList.remove( 'active' )
}

/**
 * WC Customer Lists - Account page
 */
;( () => {
    const Customer_List = {
        endpoint: '/wp-admin/admin-ajax.php',
        actionPrefix: 'shiftr_wc_customer_list',
        /**
         * Start the object.
         */
        init: function() {
            Customer_List.collateProductData()
            Customer_List.renderDynamicForm()

            document.querySelector( '.create_customer_list' )?.addEventListener( 'click', Customer_List.createList )

            document.querySelectorAll( 'ul.products .add_to_list_button' )?.forEach( btn => btn.addEventListener( 'click', Customer_List.addProductToList ) )

            document.querySelector( '.single_add_to_list_button' )?.addEventListener( 'click', Customer_List.addProductToList )
            document.querySelector( '.customer_list_modal .close' )?.addEventListener( 'click', Customer_List.closeModal )

            document.querySelector( 'button#new-customer-list' )?.addEventListener( 'click', Customer_List.addNewList )
            document.querySelectorAll( 'ul.customer-lists .remove' )?.forEach( removeEl => removeEl.addEventListener( 'click', Customer_List.deleteList ) )

            document.querySelectorAll( 'ul.list-items .remove' )?.forEach( removeEl => removeEl.addEventListener( 'click', Customer_List.removeProductFromList ) )
        },
        setAction: function( name = '' ) {
            return `${ Customer_List.actionPrefix }_${ name }`
        },
        /**
         * Open the modal.
         */
        openModal: function() {
            const modal = document.querySelector( '.customer_list_modal' )

            if ( modal ) {
                modal.classList.add( 'visible' )
                modal.setAttribute( 'aria-hidden', false )
            }
        },
        /**
         * Close model 
         */
        closeModal: function() {
            const modal = document.querySelector( '.customer_list_modal' ),
                  form = modal.querySelector( 'form' ),
                  formSubmissionMessage = modal.querySelector( '.form-submission-message' )

            modal.classList.remove( 'visible' )
            modal.setAttribute( 'aria-hidden', true )

            form.classList.remove( 'submit-success' )

            if ( formSubmissionMessage ) {
                form.removeChild( formSubmissionMessage )
            }
        },
        /**
         * Update the modals contents with new product info.
         * 
         * @param {object} product The product object
         */
        updateModal: function( product ) {
            const modal = document.querySelector( '.customer_list_modal.add_product_customer_list_modal' )

            console.log( product )

            if ( modal ) {
                modal.querySelector( '.product-title' ).textContent = product.name
                modal.querySelector( 'input[name="product"]' ).value = product.id
            }
        },
        /**
         * Create new customerlist
         */
        createList: function( event ) {
            Customer_List.openModal()

            const form = Customer_List.getForm( 'create' )

            form.addEventListener( 'submit', event => {
                event.preventDefault()

                const body = new FormData( event.target )

                Customer_List.block( document.querySelector( '.customer_list_modal' ) )
                event.submitter.disabled = true

                fetch( Customer_List.endpoint, {
                    method: 'post',
                    body
                })
                    .then( res => res.json() )
                    .then( data => {
                        console.log( data )

                        if ( data.success ) {
                            Customer_List.formSubmitSuccess( `Created list: ${ data.list.name }`, event.target )

                            Customer_List.autoCloseModal()
                        } else {
                            alert( data.errors?.join( ' | ' ) )
                        }


                        Customer_List.unblock( document.querySelector( '.customer_list_modal' ) )
                        event.submitter.disabled = false
                    })
            })
        },
        /**
         * Get the form element.
         * 
         * @param {string} formName The form name
         * @returns HTMLElement
         */
        getForm: function( formName = '' ) {
            let form = null
            /**
             * Allows a match against both a shorthand and full form name.
             */
            switch ( formName ) {
                case 'create':
                case 'create-customer_list_form':
                    form = document.forms['create-customer_list_form']
                    break

                case 'add_product':
                case 'add_product-customer_list_form':
                    form = document.forms['add_product-customer_list_form']
                    break
            }

            return form
        },
        /**
         * Delete a list
         */
        deleteList: function( event ) {
            console.log( 'Removing list' )

            const listID = parseInt( event.target.dataset.listId )

            if ( ! confirm( 'Are you sure?' ) ) {
                return
            }

            const body = new FormData;
            body.append( 'action', Customer_List.setAction( 'delete' ) )
            body.append( 'customer_id', shiftr.WC.customer_id )
            body.append( 'list_id', listID )

            fetch( Customer_List.endpoint, {
                method: 'post',
                body
            })
                .then( res => res.json() )
                .then( data => {
                    console.log( data )

                    location.reload()
                })
        },
        /**
         * Add product to list
         */
        addProductToList: function( event ) {
            event.preventDefault()
            /**
             * handle archive specific functionality.
             */
            if ( document.body.classList.contains( 'archive' ) ) {
                const productId = parseInt( event.target.dataset.productId )

                const product = Customer_List.productsData.find( _product => {
                    return _product.id === productId
                })

                Customer_List.updateModal( product )
            }

            Customer_List.openModal()
        },
        /**
         * Remove product to list
         */
        removeProductFromList: function( event ) {
            event.preventDefault()

            const formData = new FormData

            const { target } = event

            formData.append( 'action', Customer_List.setAction( 'remove_product' ) )
            formData.append( 'list_id', target.dataset.listId )
            formData.append( 'product', target.dataset.productId )

            fetch( Customer_List.endpoint, {
                method: 'post',
                body: formData
            })
                .then( res => res.json() )
                .then( data => {
                    console.log( data )

                    if ( data.success ) {
                        location.reload()
                    }
                })

        },
        /**
         * Render dynamic form
         */
        renderDynamicForm: function() {
            const model = document.querySelector( '.customer_list_modal.add_product_customer_list_modal' )
            const form = Customer_List.getForm( 'add_product' )
            
            if ( form ) {
                const select = form.elements["customer-lists"],
                      options = select.options

                const createToAdd = document.querySelector( '.back_to-add_to_list' )
                const listNameInput = form.querySelector( '[name="list_name"]' )

                createToAdd.addEventListener( 'click', event => {
                    form.classList.remove( 'as-create-list' )
                })

                const selectedOption = options[ options.selectedIndex ]
                const jsSelect = document.createElement( 'div' )
                jsSelect.classList.add( 'js-select' )

                const markup = `
                    <div class="selected">
                        ${ selectedOption?.label || '' }
                        <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="8.838" height="5.364" viewBox="0 0 8.838 5.364">
                        <path id="chevron-down" d="M9.732,128.716,5.8,124.782a.486.486,0,0,1,0-.687l.459-.459a.486.486,0,0,1,.686,0l3.132,3.117,3.132-3.117a.486.486,0,0,1,.686,0l.459.459a.486.486,0,0,1,0,.687l-3.933,3.933A.486.486,0,0,1,9.732,128.716Z" transform="translate(-5.656 -123.494)" fill="#231f20"/>
                      </svg>
                      </span>
                    </div>
                    <div class="dropdown">
                        ${
                            [...options].map( option => {
                                if ( option.value === '0' ) {
                                    return ''
                                }

                                return `
                                    <span data-value="${ option.value }" data-label="${ option.label }"${ option.disabled ? ' data-disabled="disabled"' : '' }>
                                        ${ option.label }
                                        ${ option.disabled ? `
                                            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="var(--c-secondary)">
                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z"/>
                                            </svg>
                                        ` : '' }
                                    </span>
                                `
                            }).join( '' )
                        }
                        <button type="button" class="create-list"><span aria-hidden="true"></span>Create new list</button>
                    </div>
                `

                jsSelect.innerHTML = markup
                form.querySelector( 'div.add-product' )?.insertBefore( jsSelect, select )
                select.classList.add( 'active' )

                /**
                 * Attach event listeners
                 */
                const selected = jsSelect.querySelector( '.selected' )
                const dropdown = jsSelect.querySelector( '.dropdown' )
                const createListTrigger = jsSelect.querySelector( 'button.create-list' )

                selected.addEventListener( 'click', () => {
                    jsSelect.classList.toggle( 'dropdown-active' )
                })

                dropdown.addEventListener( 'click', ({ target }) => {
                    if ( target.nodeName !== 'SPAN' ) {
                        return
                    }

                    if ( !!target.dataset.disabled ) {
                        return
                    }

                    const value = target.dataset.value

                    select.value = value
                    selected.innerHTML = target.dataset.label
                    jsSelect.classList.remove( 'dropdown-active' )
                })

                createListTrigger.addEventListener( 'click', event => {
                    select.value = ''
                    form.classList.add( 'as-create-list' )
                    listNameInput.focus()
                })

                if ( options.length < 2 ) {
                    select.value = ''
                    form.classList.add( 'as-create-list', 'disable-go_back' )
                    listNameInput.focus()
                }

                /**
                 * Submitting
                 */
                form.addEventListener( 'submit', event => {
                    event.preventDefault()

                    const submitType = event.submitter?.name
                    let action = 'add_product'

                    if ( submitType === 'create_list' ) {
                        action = 'create'
                    }

                    const formData = new FormData( event.target )

                    formData.append( 'action', Customer_List.setAction( action ) )

                    fetch( Customer_List.endpoint, {
                        method: 'post',
                        body: formData
                    })
                        .then( res => res.json() )
                        .then( data => {
                            console.log( data )

                            if ( data.success ) {
                                Customer_List.formSubmitSuccess( `Added to list: ${ data.list_title || data.list.name }`, event.target )

                                setTimeout( () => {
                                    Customer_List.closeModal()
                                }, 5000 )
                            }

                            Customer_List.handleErrors( data )
                        })
                })
            }
        },
        /**
         * Create a form submission message
         */
        createFormSubmissionMessage: function( message = '', form = null ) {
            const messageWrapper = document.createElement( 'span' )

            messageWrapper.classList.add( 'form-submission-message' )
            messageWrapper.innerHTML = message

            form.appendChild( messageWrapper )
        },
        formSubmitSuccess: function( message = '', form = null ) {
            form.classList.add( 'submit-success' )
            Customer_List.createFormSubmissionMessage( message, form )

            form.reset();
        },
        handleErrors: function( data ) {
            if ( !!data.errors?.length ) {
                alert( data.errors?.join( "\n" ) )
            }
        },
        /**
         * Block an element with an overlay.
         * 
         * @param {HTMLElement} el The element to block
         */
        block: function( el = null ) {
            el.classList.add( 'blocked' )
        },
        /**
         * Unblock an element with an overlay.
         * 
         * @param {HTMLElement} el The element to unblock
         */
        unblock: function( el = null ) {
            el.classList.remove( 'blocked' )
        },
        /**
         * Set the modal to auto close after a set duration.
         * 
         * @param {integer} duration The duration in milliseconds
         * @returns setTimeout
         */
        autoCloseModal: function( duration = 3000 ) {
            return setTimeout( () => {
                Customer_List.closeModal()
            }, duration )
        },
        /**
         * Collate product data on an archive
         */
        collateProductData: function() {
            const products = document.querySelectorAll( 'ul.products li.product' )

            Customer_List.productsData = [ ...products ]?.map( product => {
                const id = parseInt( product.classList.value.match( /post-(\d+)/ )?.[1] )

                return {
                    id,
                    name: product.querySelector( 'h2' ).textContent
                }
            })
        }
    }

    Customer_List.init()
})();


/**
 * Customer account.
 */
;( () => {
    const editAccountForm = document.forms.woocommerce_edit_account

    return

    if ( editAccountForm ) {
        const rows = editAccountForm.querySelectorAll( '.form-row' )

        rows.forEach( row => {
            const input = row.querySelector( 'input' ),
                  editButton = row.querySelector( '.edit' )

            input.disabled = true

            row.addEventListener( 'click', event => {
                event.stopPropagation()
            })

            editButton?.addEventListener( 'click', () => {
                editButton.disabled = true
                editButton.setAttribute( 'aria-hidden', true )
                input.disabled = false
                input.focus()
                row.classList.toggle( 'focus' )
            })
        })

        window.addEventListener( 'click', () => {
            rows.forEach( row => {
                row.classList.remove( 'focus' )
                row.querySelector( 'input' ).disabled = true
                row.querySelector( '.edit' ).disabled = false
                row.querySelector( '.edit' ).setAttribute( 'aria-hidden', false )
            })
        })
    }

})();


/**
 * Stockist geocoding.
 */
;( () => {
    if ( ! document.body.classList.contains( 'page-id-8' ) ) return

    const formSearch = document.forms.find_a_stockist
    const geolocateTrigger = formSearch.querySelector( 'button[name="geolocate"]' )
    const geolocatePopup = document.querySelector( '.geolocating-popup' )

    const messages = {
        calculating: 'Calculating your current address, please wait...',
        success: 'Success, redirecting you now...'
    }

    /**
     * Handle focus state of search field 
     */
    formSearch.querySelector( 'input[type="search"]' ).addEventListener( 'focus', e => {
        e.target.parentElement.classList.add( 'field-focus' )
    })
    formSearch.querySelector( 'input[type="search"]' ).addEventListener( 'blur', e => {
        e.target.parentElement.classList.remove( 'field-focus' )
    })


    function success( position ) {
        const url = new URL( window.location.origin + window.location.pathname )

        url.searchParams.set( 'latitude', position.coords.latitude )
        url.searchParams.set( 'longitude', position.coords.longitude )

        geolocatePopup.querySelector( 'span' ).textContent = messages.success

        /**
         * GTM tracking
         */
        window.dataLayer = window.dataLayer || []

        window.dataLayer.push({
            event: 'whereToBuyNavGeo'
        })

        /**
         * Timeout allows for tags in Tag Manager to fire.
         */
        setTimeout( () => {
            window.location.href = url
        }, 1000 )
    }

    function error( err ) {
        console.warn( err )

        geolocatePopup.querySelector( 'span' ).textContent = `ERR CODE: ${ err.code } - ${ err.message }`

        setTimeout( () => {
            document.body.classList.remove( 'no-scroll', 'overlay-active' )
            geolocatePopup.classList.remove( 'is-visible' )
            geolocatePopup.setAttribute( 'aria-hidden', true )
        }, 5000 )
    }

    geolocateTrigger.addEventListener( 'click', e => {
        console.log( e )
        if ( formSearch.classList.contains( 'coords' ) )  {
            /**
             * Maybe clear value?
             */
            formSearch.querySelector( 'input[type="search"]' ).value = ''
            formSearch.classList.remove( 'coords' )
            formSearch.querySelector( 'input[type="search"]' ).focus()

        } else {
            navigator.geolocation.getCurrentPosition( success, error, { timeout: 5000 } )

            geolocatePopup.querySelector( 'span' ).textContent = messages.calculating

            document.body.classList.add( 'no-scroll', 'overlay-active' )
            geolocatePopup.classList.add( 'is-visible' )
            geolocatePopup.setAttribute( 'aria-hidden', false )
        }
    })
})();


/**
 * Load more posts
 */
 ;( () => {
    if ( ! document.querySelector( 'a[href*="?load_more"]' ) ) return
    
    const loadMoreTrigger = document.querySelector( 'a[href*="?load_more"]' )

    const url = new URL( loadMoreTrigger.href )
    const loadMoreParams = new URLSearchParams( url.search )

    const loadMoreData = {
        postType: loadMoreParams.get( 'load_more' )
    }

    const loop = document.querySelector( `ul.${ loadMoreData.postType }s` )
    let page = 1
    let maxPageReached = false

    const event = new Event( 'loadmoreposts' );

    loadMoreTrigger.addEventListener( 'click', e => {
        /** We're using fetch only, so if it isn't available, just go old school */
        if ( window.fetch ) e.preventDefault()

        if ( maxPageReached ) return

        // Update wording...
        let orgWording = loadMoreTrigger.innerHTML
        loadMoreTrigger.innerHTML = 'Loading more...'

        const actionData = new FormData()
        actionData.append( 'action', 'load_more_posts' )
        actionData.append( 'next_page', page + 1 )

        for ( const [ key, value ] of loadMoreParams ) {
            actionData.append( key, value )
        }
        

        if ( loadMoreParams.get( 'load_more' ) === 'stockist' ) {
            actionData.append( 'stockists_by_distance', loadMoreTrigger.dataset.stockistsByDistance )
            actionData.append( 'search_value', JSON.stringify( loadMoreTrigger.dataset.stockistsSearchValue ) )
        }

        fetch( shiftr.ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: actionData
        })
        .then( response => response.json() )
        .then( data => {
            page++

            loop.innerHTML = loop.innerHTML + ( data?.fragment || '' )

            if ( page === data.max_num_pages ) {
                loadMoreTrigger.classList.add( 'max-pages-reached' )
                maxPageReached = true
            }

            const newPosts = loop.querySelectorAll( `li.${ loadMoreData.postType }.delay-entry` )

            newPosts.forEach( ( post, i ) => {
                setTimeout( () => post.classList.remove( 'delay-entry' ), 50 * ( i + 1 ) )
            })

            loadMoreTrigger.innerHTML = orgWording

            /**
             * Reset product feature triggers.
             */
            body.dispatchEvent( event )
        })
    })
})();


/**
 * WC - quantity buttons.
 */
;( () => {
    const qtyInstances = document.querySelectorAll( '.quantity' )

    function handleQuantityInput( quantity ) {
        const input = quantity.querySelector( 'input.qty' ),
              minus = quantity.querySelector( 'button.minus' ),
              plus  = quantity.querySelector( 'button.plus' )

        if ( input.value === input.min || !input.value ) {
            minus.disabled = true
        }

        input.addEventListener( 'change', event => {
            const { target } = event

            if ( target.value === target.min ) {
                minus.disabled = true
            } else if ( target.value === target.max ) {
                plus.disabled = true
            } else {
                minus.disabled = false
                plus.disabled = false
            }
        })

        minus.addEventListener( 'click', event => {
            event.preventDefault()

            const currValue = input.value

            if ( currValue === input.min ) {
                return
            }

            input.value = parseInt( currValue ) - 1
            input.dispatchEvent( new Event( 'change' ) )
        })

        plus.addEventListener( 'click', event => {
            event.preventDefault()

            const currValue = input.value || 0

            if ( currValue === input.max ) {
                return
            }

            input.value = parseInt( input.value || 0 ) + 1
            input.dispatchEvent( new Event( 'change' ) )
        })
    }

    qtyInstances?.forEach( handleQuantityInput )
})();
